export const formatValidationName = (input: string) =>
	input
		.split('-')
		.map((w) => w.charAt(0).toUpperCase() + w.slice(1))
		.join(' ');

export const validationInfoContent = {
	'reject-unrecognized-words':
		'We calculate this threshold by dividing the the number of non-dictionary words in the students’ answer by total words. ' +
		'So if the threshold is 50%, and the student’s answer is 7 words, at least 4 of those words must be identifiable by our dictionary.',
	'reject-excess-repetition':
		'We calculate this threshold by dividing the the number of unique words in the students’ answer by total words. ' +
		'So if the threshold is 30%, and the student’s answer is 10 words, at least 3 of those words must be unique.',
	'min-word-count': 'Students cannot enter fewer words than the given threshold.',
	'max-word-count': 'Students cannot enter more words than the given threshold.',
	'match-expression':
		'Students must enter responses that match the specific expression. Regular expressions are permitted.',
	'partial-match':
		'Unless set, the whole student input must match exactly for the validation to pass.',
	'reject-match': 'If set, student input must *not* match for the validation to pass.'
};

export const commonPayload = (element, courseId) => {
	return { elementId: element.family_id, courseId };
};

export const isExactMatchElementValidation = (validation) => {
	return validation.name === 'exact-match' && validation.source === 'element';
};

export const isExactMatchConfigValidation = (validation) => {
	return validation.name === 'exact-match' && validation.source !== 'element';
};

export const sanitizeValidations = (validations) => {
	// remove clientId created on the client side
	return validations.map((validation) => {
		const { clientId, ...val } = validation;
		return val;
	});
};
